import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Search, KeyboardArrowDown } from "@material-ui/icons";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { getPendingProfileListAction } from "./../../actions/UserActions";
import noRecord from "./../../assets/img/no-record.png";
import PhoneNumber from "../Common/phoneNumber";
import * as code from "./../../config/Constants";

class PendingProfiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      users: [],
      originalUsers: [],
      filteredUsers: [],
      searchParam: "",
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      width: "25%",
    },
    {
      name: "Company Name",
      selector: "company",
      sortable: true,
      width: "25%",
    },
    {
      name: "Mobile No.",
      selector: "mobile",
      sortable: true,
      width: "25%",
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "25%",
    },
  ];

  componentWillMount() {
    this.getPendingProfileList(this.state.page);
  }

  getPendingProfileList(pageIndex) {
    this.props
      .getPendingProfileListAction(this.state.recordPerPage, pageIndex)
      .then((res) => {
        this.setState({
          users: this.props.userDetails || [],
          originalUsers: this.props.userDetails || [],
          filteredUsers: this.props.userDetails || [],
        });
      });
  }

  changePage = async (page) => {
    this.getPendingProfileList(page - 1);
  };
  /**
   * @desc search request based on input data
   * @param {*} param
   */
  search(param) {
    param = param.trim();
    var requests = [];
    requests = this.state.filteredUsers.filter((o) => {
      var found = false;
      Object.keys(o).forEach((v) => {
        if (
          v == "firstname" ||
          v == "lastname" ||
          v == "mobileNumber" ||
          v == "brokerLicenseNo"
        ) {
          let item = o[v] + "";
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        } else if (v == "email") {
          let item = o[v].address + "";
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        }
      });
      return found;
    });
    this.setState({
      users: requests,
      searchParam: param,
      isSearched: param.trim() == "" ? false : true,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.users.length; i < len; i++) {
      let user = this.state.users[i];

      let data = {
        id: user._id,
        name:
          // <Link to={"/UserProfile/" + user._id} className="p-0 text-capitalize">
          //   {user.firstname} {user.lastname}
          // </Link>
          user.firstname + " " + user.lastname,
        company:
          user.dsd &&
          user.dsd.roles[0] &&
          user.dsd.roles[0] &&
          user.dsd.roles[0].companyInformation &&
          user.dsd.roles[0].companyInformation.name
            ? user.dsd.roles[0].companyInformation.name
            : "",
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
      };

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">Pending Profiles</h4>
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                  this.setState({ searchParam: e.target.value });
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
          <Col className="col-auto pl-0">
            <Button
              variant="primary"
              className={"btn-blue btn-blue btn-head w-140"}
              onClick={() => this.props.history.push("/RegistrationRequests")}
            >
              Registration Requests
            </Button>
          </Col>
        </Row>

        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              highlightOnHover={true}
              className="rdt-requests"
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Profiles Found</p>
                  </div>
                </div>
              }
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalPending}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userDetails: state.reducer.userDetails,
    totalPending: state.reducer.totalPending,
  };
};
export default connect(
  mapStateToProps,
  {
    getPendingProfileListAction,
  }
)(PendingProfiles);
